// src/layout/AppLayout/styles.js
import { styled } from '@mui/material/styles';
import { Typography, ListItemButton, Box } from '@mui/material';

export const LogoContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.outlineVariant}`,
  position: 'relative',
}));

export const LogoIconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: theme.palette.primaryContainer,
  color: theme.palette.onPrimaryContainer,
  padding: theme.spacing(1),
  marginRight: theme.spacing(1.5),
  border: `1px solid ${theme.palette.outlineVariant}`,
}));

export const Main = styled('main')(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
  transition: 'padding 0.3s ease',
}));

export const Logo = styled(Typography)(({ theme }) => {
  return {
    fontWeight: 800,
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    letterSpacing: '-0.02em',
  };
});

export const StyledListItemButton = styled(ListItemButton)(({ theme, active }) => {
  const isActive = active === 'true';
  const isDark = theme.palette.mode === 'dark';
  
  const activeBg = isDark
    ? 'rgba(181, 235, 185, 0.08)'
    : 'rgba(0, 65, 73, 0.05)';
  
  return {
    borderRadius: '4px',
    margin: '4px 12px',
    padding: '10px 16px',
    background: isActive ? activeBg : 'transparent',
    borderLeft: `4px solid ${isActive ? theme.palette.primary.main : 'transparent'}`,
    color: isActive ? theme.palette.primary.main : theme.palette.text.primary,
    
    '&:hover': {
      background: isActive 
        ? activeBg 
        : (isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(0, 0, 0, 0.02)'),
      '& .MuiListItemIcon-root': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiListItemIcon-root': {
      color: isActive ? theme.palette.primary.main : theme.palette.text.secondary,
      minWidth: '36px',
      transition: 'color 0.2s ease',
    },
    '& .MuiListItemText-primary': {
      color: isActive ? theme.palette.text.primary : theme.palette.text.secondary,
      fontWeight: isActive ? 700 : 500,
      fontSize: '0.875rem',
      letterSpacing: '0.01em',
      transition: 'color 0.2s ease',
    },
    transition: 'all 0.2s ease',
  };
});